import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { RateStatusDto } from '@cradua/data';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';

@Component({
  selector: 'cradua-rate-status-container',
  templateUrl: './rate-status-container.component.html',
  styleUrls: ['./rate-status-container.component.scss']
})
export class RateStatusContainerComponent implements OnInit {

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  ratestatuss$: Observable<RateStatusDto[]>;
  loading: boolean;
  isLoadingRateStatus$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
  ) {}

  ngOnInit() {
    this.isLoadingRateStatus$ = this.gatwayFacade.isLoadingGateway("RateStatus");
    this.ratestatuss$ = this.gatwayFacade.loadGateway("RateStatus");
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteRateStatus(deletedValue: any) {
    this.gatwayFacade.remove("RateStatus", deletedValue);
  }


// this method control both the create and update

  onSubmitRateStatus(formValue: any) {
    // event.preventDefault();
    const pullData = formValue.RateStatuss;

// declare two empty arrays to hold update and create data
  const allUpdates = [] ;
  const addAllRateStatus = [];


// loop through the form data to check for update and create
  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id !== null) {
      allUpdates.push(pullData[i]);
    } else {
      delete pullData[i].id;
      addAllRateStatus.push(pullData[i]);
    }
  }

// check if the addAllRateStatus array is not empty, then dispatch the data to the store
   if(addAllRateStatus.length > 0) {
    this.gatwayFacade.add('RateStatus', addAllRateStatus);
   }

   if(allUpdates.length > 0) {
     // dispatch update data to the store
    this.gatwayFacade.update('RateStatus', allUpdates, ['id']);
  }

   }


}
